module.exports = __webpack_public_path__ + "media/images/article/2021_13-c61f12a9df8d4f9e1027f95522d83ba7.png";